export class AssetUpdatePermissionsModel {
    canUpdateMetadata: boolean;
    canUpdateLifecycle: boolean;
    canUpdateOwnership: boolean;
    canUpdateProcessInformation: boolean;
    canUpdateDocuments: boolean;
    canUpdateHyperlinks: boolean;

    constructor(permissions: string[]) {
        this.canUpdateMetadata = permissions.includes('ASSET_UPDATE_METADATA');
        this.canUpdateLifecycle = permissions.includes('ASSET_UPDATE_LIFECYCLE');
        this.canUpdateOwnership = permissions.includes('ASSET_UPDATE_OWNERSHIP');
        this.canUpdateProcessInformation = permissions.includes('ASSET_UPDATE_PROCESSINFORMATION');
        this.canUpdateDocuments = permissions.includes('ASSET_UPDATE_DOCUMENTS');
        this.canUpdateHyperlinks = permissions.includes('ASSET_UPDATE_HYPERLINKS');
    }
}
